// extracted by mini-css-extract-plugin
export default {"icon-accordion":"IconAccordion_icon-accordion__-zH0k","indent":"IconAccordion_indent__oQagn","description":"IconAccordion_description__X+DdR"};